const DEFAULT_STATE = {
  findings: [],
  selectedFinding: {},
  dropdownType: '', // finding, impression_settings, finding_impression
  activeFieldType: '',
  activeFieldKey: ''
}
export default function examFindingReducer(state = DEFAULT_STATE, action) {

  switch (action.type) {

    case 'EXAM_FINDINGS':
      return { ...state, findings: action.data };

    case 'EXAM_SELECTED_FINDING':
      return { ...state, selectedFinding: action.data };

    case 'EXAM_FINDING_INFO':
      return { ...state, ...action.data };

    case 'EXAM_FINDING_RESET':
      return { ...state, ...DEFAULT_STATE };

    default:
      return state;
  }
}